const SESSION_STORAGE = {
    DATA: {
        intro: true,
        limitedScreeningIntro: true,
    },
    KEY: "twstwdl-3dlive",
};
export default class Storage {
    constructor() {
        // セッションストレージを取得
        const saved = JSON.parse(sessionStorage.getItem(SESSION_STORAGE.KEY) || "{}");
        this.data = { ...SESSION_STORAGE.DATA, ...saved };
    }

    set(prop, val) {
        if (prop && typeof val != "undefined") {
            this.data[prop] = val;
        }

        // セッションストレージを保存
        sessionStorage.setItem(SESSION_STORAGE.KEY, JSON.stringify(this.data));
    }
}
